import { createContext, use } from "react";

import { useTravellersSelectionContext } from "@/features/travellers/contexts/TravellersSelectionContext/TravellersSelectionContext";

export type HotelTravellersSelectionContextValue = {
  leadTravellerId: string | null;
  setLeadTravellerId: (id: string | null) => void;
};

export const HotelTravellersSelectionContext =
  createContext<HotelTravellersSelectionContextValue | null>(null);

export const useHotelTravellersSelectionContext = () => {
  const travellersSelectionContext = useTravellersSelectionContext();

  const context = use(HotelTravellersSelectionContext);
  if (!context) {
    throw new Error(
      "useHotelTravellersSelectionContext must be used within a HotelTravellersSelectionProvider",
    );
  }
  return { ...travellersSelectionContext, ...context };
};
